import { useEffect, useMemo, useState } from 'react';
import { useModuleSettings } from '../contexts/ModuleSettingsContext';
import { useComprasPurchaseSite } from '../contexts/ComprasPurchaseSiteContext';

/** Parámetros API para listados según vista de sede. */
export function buildComprasSiteListParams(siteView, selectedPurchaseSite, enabled) {
  if (!enabled) return {};
  if (siteView === 'without') return { without_purchase_site: 1 };
  if (selectedPurchaseSite?.id) return { purchase_site_id: selectedPurchaseSite.id };
  return {};
}

export function useComprasSiteListParams(siteView) {
  const { comprasPurchaseSitesEnabled } = useModuleSettings();
  const { selectedPurchaseSite, comprasSiteView } = useComprasPurchaseSite();
  const effectiveView = siteView ?? comprasSiteView ?? 'active';
  const purchaseSiteId = selectedPurchaseSite?.id ?? null;
  return useMemo(
    () => buildComprasSiteListParams(effectiveView, selectedPurchaseSite, comprasPurchaseSitesEnabled),
    [effectiveView, purchaseSiteId, comprasPurchaseSitesEnabled]
  );
}

/** ID de sede para crear documentos o cargar referencias. */
export function useComprasPurchaseSiteId() {
  const { comprasPurchaseSitesEnabled } = useModuleSettings();
  const { selectedPurchaseSite, isWithoutSiteMode } = useComprasPurchaseSite();
  if (!comprasPurchaseSitesEnabled || isWithoutSiteMode || !selectedPurchaseSite?.id) return null;
  return selectedPurchaseSite.id;
}

/** Pestaña activa/sin sede sincronizada con la selección en /compras/select-site. */
export function useComprasSiteViewState() {
  const { comprasSiteView, setComprasSiteView } = useComprasPurchaseSite();
  const [siteView, setSiteView] = useState(comprasSiteView === 'without' ? 'without' : 'active');

  useEffect(() => {
    setSiteView(comprasSiteView === 'without' ? 'without' : 'active');
  }, [comprasSiteView]);

  const onSiteViewChange = (view) => {
    setSiteView(view);
    setComprasSiteView(view);
  };

  return { siteView, onSiteViewChange };
}
